export default {
  props: ['text'],
  data:
		function () {
			return {
			}
	},
  created: function () {
  },
  methods: {
 }
}
